import { useState } from 'react';

import {
  signInWithEmailAndPassword
} from 'firebase/auth';

import { auth } from './firebase';

function Login() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');

  const iniciarSesion = async (e) => {

    e.preventDefault();

    try {

      await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

    } catch (err) {

      setError('Correo o contraseña incorrecta');

    }
  };

  return (
    <div style={styles.container}>

      <div style={styles.card}>

        <h1 style={styles.logo}>VITA</h1>

        <p style={styles.subtitle}>
          Plataforma de Viabilidad Territorial
        </p>

        <form onSubmit={iniciarSesion}>

          <input
            style={styles.input}
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            style={styles.input}
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && (
            <p style={styles.error}>
              {error}
            </p>
          )}

          <button style={styles.button}>
            Ingresar
          </button>

        </form>

      </div>

    </div>
  );
}

const styles = {

  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#0b1f2e'
  },

  card: {
    width: '400px',
    background: 'white',
    padding: '40px',
    borderRadius: '18px',
    boxShadow: '0 15px 40px rgba(0,0,0,0.25)'
  },

  logo: {
    fontSize: '48px',
    marginBottom: '10px',
    color: '#0b1f2e'
  },

  subtitle: {
    color: '#667085',
    marginBottom: '30px'
  },

  input: {
    width: '100%',
    padding: '14px',
    marginBottom: '18px',
    borderRadius: '10px',
    border: '1px solid #ccc'
  },

  button: {
    width: '100%',
    padding: '14px',
    background: '#1f8f5f',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px'
  },

  error: {
    color: '#b42318',
    marginBottom: '15px'
  }
};

export default Login;